/**
 * @name credit-card-minus
 * @description Lucide SVG string.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMjIgMTNWN2EyIDIgMCAwMC0yLTJINGEyIDIgMCAwMC0yIDJ2MTBhMiAyIDAgMDAyIDJoOC41MzYiIC8+CiAgPHBhdGggZD0iTTIyIDEwSDIiIC8+CiAgPHBhdGggZD0iTTYgMTRoMiIgLz4KICA8cGF0aCBkPSJNMTYgMTdoNiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/credit-card-minus
 * @see https://lucide.dev/guide/packages/lucide-static - Documentation
 *
 * @returns {String}
 *
 */
const CreditCardMinus: string = `
<svg
  class="lucide lucide-credit-card-minus"
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
>
  <path d="M22 13V7a2 2 0 00-2-2H4a2 2 0 00-2 2v10a2 2 0 002 2h8.536" />
  <path d="M22 10H2" />
  <path d="M6 14h2" />
  <path d="M16 17h6" />
</svg>
`;

export default CreditCardMinus;
